import axios from 'axios'

export default {
    update (token, time) {
        return axios.put('event/checkpoint/' + token + '/time', time)
    }
}
